module.exports = __webpack_public_path__ + "img/1_2.6aec08d2.png";